import muster from '@dbk-legacy/muster';

const MAPPING = {
  uniqueId: 'web',
  deviceId: 'web',
  model: 'web',
  systemName: 'web',
  systemVersion: 'web',
  timezone: 'web',
};

export default () => {
  const routeConfig = muster();

  Object.entries(MAPPING).forEach(([path, methodName]) => {
    routeConfig.path(`device.${path}`, ({ res }) =>
      res.value(methodName)
    );
  });

  return routeConfig;
};
